import { useQuery } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

type PostHogConfig = {
  apiKey: string | null;
  host: string | null;
};

export const fetchPostHogConfig = async (): Promise<PostHogConfig> => {
  const response = await axios.get<PostHogConfig>(`/event-tracking/config`);
  return response.data;
};

export const usePostHogConfig = () => {
  console.log("usePostHogConfig hook called!");

  const {
    error,
    isPending: loading,
    data: config,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["posthog_config"],
    queryFn: async () => {
      console.log("Fetching PostHog config...");
      try {
        const result = await fetchPostHogConfig();
        console.log("PostHog config fetched:", result);
        return result;
      } catch (err) {
        console.error("Failed to fetch PostHog config:", err);
        throw err;
      }
    },
    enabled: true, // Explicitly enable the query
    refetchOnMount: true,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 3,
    retryDelay: 1000,
  });

  console.log("usePostHogConfig hook state:", {
    loading,
    isLoading,
    isFetching,
    config,
    error,
    hasConfig: !!config,
  });

  return { config: config || { apiKey: null, host: null }, loading, error };
};
